export { ThemeProvider } from 'react-fela';
export function objectKeys(t) {
  return Object.keys(t);
}